import React from "react";
import { sweetalert } from "../../App";
import { hideModal, parseDateForCustomDate, 
  getLabel} from "../../util/FormatUtil";
import Overlay from "../Overlay";
import { CustomFieldBuilder } from "../../customfields/CustomFieldBuilder"
import { isEmptyObject } from "jquery";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import { FaCameraRetro } from "react-icons/fa";
import BarcodeScannerComponent from "../BarcodeScannerComponent";
import GetField from "../../customfields/GetField";
import TestType from "../../types/TestType";
import { getFieldReadOnly, FieldPermissions } from "../../util/RolePermissions";
import moment from "moment";
import { bloodLeadServiceID, rabiesServiceID } from "../../types/Service";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import AutoComplete from "../admin/Autocomplete";
import Validator, { ValidationEntry } from "../../validation/Validator";
import { Validators } from "../../validation/Validators";
import ProviderAPI from "../../network/ProviderAPI";
import { SubmittingProvider } from "../../types/SubmittingProvider";
import { isBlank, isOnlyWhitespace } from "../../util/ValidationUtil";
import { getPanelBillOtherHCode, getSubmitterBillOtherHCode } from "../../util/BillOtherMappings";



interface ServiceFormModalProps {
    submit: (e) => void,
    attachClearStateFunc?: (func) => void
    customQuestions?
    service?
    facility?
    associatedTests?
    sources?
    reviewInfo?
    showSampleInfo?
    tests?
    associatedPrices?
    states
    animalTypes?
    showProviderInfo?
    submittingProviders?
    providerSelectOptions?
    patientInformation?
    userRoles?
    fieldPermissions?: FieldPermissions
}

interface ServiceFormModalState {
    showLoading: boolean
    answeredQuestions?: any
    sampleInfo?: {
        lot: string
        specimenID: string
        serviceID
        isLabService: boolean
        memo: string
        selectedTests: TestType[]
        specimenSourceID: number,
        specimenSourceOther?: string
        bodySite: string
        collectionDate: Date | null
        animalType?
        otherAnimalType?
        SubmitterContactID?
    }
    walkinSampleInfoArrowDown: boolean
    walkinRabiesExposureInfoArrowDown: boolean
    validSources
    showScanner
    serviceSpecificTests
    serviceArrowDown: boolean
    answeredQuestionsForGetField?
    validPrices
    // showPricingInfo?:boolean
    walkinPricingInfoArrowDown: boolean
    rabiesExposureInfo: {
        OtherExposureType: string, ExposedSpecies: any, FirstName: string, LastName: string, searchAddress: string, streetAddress: string, state: string, city: string, zipcode: string, phoneNumber: string, DateOfExposure: string, DateOfCollection: string, ExposureType: any
    }[]
    providerSelectOptions:[],
    submittingProviderLabel: {label,value}
    selectedProvider?:SubmittingProvider
    providerSearchAddress?: string
    providerArrowDown?: boolean
}

export class ServiceFormModal extends React.Component<ServiceFormModalProps, ServiceFormModalState> {
    public static ID = "serviceform";
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            walkinSampleInfoArrowDown: false,
            walkinRabiesExposureInfoArrowDown: false,
            validSources: [],
            showScanner: false,
            serviceSpecificTests: [],
            serviceArrowDown: false,
            sampleInfo: { lot: '', specimenID: '', serviceID: null, isLabService: false, memo: '', selectedTests: [], specimenSourceID: null, specimenSourceOther: '', bodySite: '', collectionDate: null },
            validPrices: [],
            // showPricingInfo: false,
            walkinPricingInfoArrowDown: false,
            rabiesExposureInfo: [],
            providerSelectOptions:[],
            submittingProviderLabel: {label: "", value: null},
            providerArrowDown: false,
            providerSearchAddress: "",
        }
        this.handleScan = this.handleScan.bind(this);
    }

    componentDidMount(): void {
        $(`#${ServiceFormModal.ID}`).on('shown.bs.modal', function () {
            $(document).off('focusin.modal');
        });
    }

    componentWillReceiveProps(nextProps: Readonly<ServiceFormModalProps>, nextContext: any): void {

        if (nextProps.reviewInfo) {
            if (!isEmptyObject(nextProps.reviewInfo)) {
              // console.log(" nextProps.reviewInfo", nextProps.reviewInfo)
                let selectedTestIDs = nextProps.reviewInfo.sampleInfo ? nextProps.reviewInfo.sampleInfo.selectedTests.map(t => { return t.ID }) : null

                let validSources = this.getAssociatedSources(selectedTestIDs)
                const uniqueLabelsMap = new Map();
                validSources.forEach(obj => {
                    if (!uniqueLabelsMap.has(obj.label)) {
                        uniqueLabelsMap.set(obj.label, obj);
                    }
                })

                const nonRepeatingSpecimenSources = [...uniqueLabelsMap.values()]

                let customQuestionAnswers = { CustomFieldData: nextProps.reviewInfo.submittedAnswers }

                let existingProvider = nextProps.submittingProviders?.find(p => {
                  return String(p.ContactID) === String(nextProps.reviewInfo.sampleInfo?.SubmitterContactID)
                });
                this.setState({
                    validSources: nonRepeatingSpecimenSources,
                    answeredQuestions: nextProps.reviewInfo.submittedAnswers,
                    sampleInfo: nextProps.reviewInfo.sampleInfo,
                    answeredQuestionsForGetField: customQuestionAnswers,
                    providerSelectOptions: nextProps.providerSelectOptions,
                    submittingProviderLabel: existingProvider ? { label: existingProvider.FullName, value: existingProvider.ID } : { label: nextProps.reviewInfo.sampleInfo?.SubmitterContactID, value: nextProps.reviewInfo.sampleInfo?.SubmitterContactID },
                    selectedProvider: existingProvider,
                    providerSearchAddress: ""
                    // showPricingInfo: nextProps.service && nextProps.service.PricingIDs && nextProps.service.PricingIDs.length > 0 ? true : false
                })
            }
        }
        else {
            if (nextProps.service && this.props.tests) {
                let serviceTests = []
                for (let i = 0; i < this.props.tests.length; i++) {
                    const testElement = this.props.tests[i];
                    for (let j = 0; j < nextProps.service.Tests.length; j++) {
                        const testID = nextProps.service.Tests[j];
                        if (testElement.ID === testID) {
                            serviceTests.push(testElement)
                        }
                    }
                }

                // single-test services can only hold one selection, so only pre-select when there's no choice to make
                let selectedTests = nextProps.service.AllowMultipleTests || serviceTests.length === 1 ? serviceTests : []

                let validSources = [];
                if (selectedTests.length > 0) {
                    let shortestObj = selectedTests.reduce((min_obj, obj) => min_obj.ValidSpecimenSources.length < obj.ValidSpecimenSources.length ? min_obj : obj)
                    shortestObj.ValidSpecimenSources.map(vss => {
                        vss.IsEnabled === 1 &&  validSources.push({ label: vss.Name, value: vss.ID })
                    })
                }

                this.setState({
                    validSources: validSources,
                    answeredQuestions: {},
                    answeredQuestionsForGetField: {},
                    sampleInfo: {
                        serviceID: nextProps.service ? nextProps.service.ID : null,
                        isLabService: nextProps.service ? nextProps.service.IsLabService : null,
                        lot: '',
                        memo: '',
                        specimenID: '',
                        selectedTests: selectedTests,
                        specimenSourceID: null,
                        specimenSourceOther: '',
                        bodySite: '',
                        collectionDate: null,
                        SubmitterContactID: null
                    },
                    rabiesExposureInfo: [],
                    // showPricingInfo: nextProps.service && nextProps.service.PricingIDs && nextProps.service.PricingIDs.length > 0 ? true : false
                    providerSelectOptions: nextProps.providerSelectOptions,
                    submittingProviderLabel: {label: "", value: null},
                    selectedProvider: {} as SubmittingProvider,
                    providerSearchAddress: ""
                  })
            }
            else {
                this.setState({
                    answeredQuestions: {},
                    answeredQuestionsForGetField: {},
                    sampleInfo: {
                        serviceID: nextProps.service ? nextProps.service.ID : null,
                        isLabService: nextProps.service ? nextProps.service.IsLabService : null,
                        lot: '',
                        memo: '',
                        specimenID: '',
                        selectedTests: [],
                        specimenSourceID: null,
                        specimenSourceOther: '',
                        bodySite: '',
                        collectionDate: null,
                        SubmitterContactID: null,
                    },
                    rabiesExposureInfo: [],
                    // showPricingInfo: nextProps.service && nextProps.service.PricingIDs && nextProps.service.PricingIDs.length > 0 ? true : false
                    providerSelectOptions: nextProps.providerSelectOptions,
                    submittingProviderLabel: {label: "", value: null},
                    selectedProvider: {} as SubmittingProvider,
                    providerSearchAddress: ""
                  })
            }
        }
    }

    generateTrackingString(firstName, lastName, dob) {
      if(!firstName || !lastName || !dob) { return "" }
      // Helper function to pad or trim a string to 3 characters
      function formatNamePart(namePart) {
        if(typeof namePart === 'object') { 
          // entered new patient
          return namePart.answer.length > 3 ? namePart.answer.slice(0, 3) : namePart.answer.padEnd(3, ' ')
        } else { // selected a patient
          return namePart.length >= 3 ? namePart.slice(0, 3) : namePart.padEnd(3, ' ');
        }
      }
    
      // Extract and format name parts
      const formattedLastName = formatNamePart(lastName);
      const formattedFirstName = formatNamePart(firstName);
    
      // Format date of birth (dob) to MMDDYY
      const date = typeof dob === 'object' ? new Date(dob.answer) : new Date(dob);
      const formattedDOB = [
        String(date.getUTCMonth() + 1).padStart(2, '0'), // Month
        String(date.getUTCDate()).padStart(2, '0'),     // Day
        String(date.getUTCFullYear()).slice(-2)        // Year
      ].join('');
    
      // Combine parts into the tracking string and UPPERCASE 
      return (formattedLastName + formattedFirstName + formattedDOB).toUpperCase();
    }

    handleNPIChange(e): void {
      if (!e || !e.CustomFieldData) {
        return;
      }
      let npiField = e.CustomFieldData['NPI #'];
      let npiNumber = npiField ?
        typeof npiField === 'object' ?
          npiField.answer :
          npiField :
        null;

      this.setState((prevState) => ({
        selectedProvider: {
          ...prevState.selectedProvider,
          NPI_Number: npiNumber
        },
        answeredQuestionsForGetField: e,
      }))
    }

    handleSave() {
        let errorInRabies = false;
        // if ((!this.state.sampleInfo || !this.state.sampleInfo.specimenID) && this.props.service?.IsLabService && this.props.service?.SampleType === 0) {
        //     return sweetalert.fire({ icon: 'error', title: '', text: 'Specimen ID must be provided.' })
        // }


        if (this.props.service?.ID === rabiesServiceID) {

            this.state.rabiesExposureInfo.forEach((elem, index) => {
                if (elem.DateOfExposure || elem.DateOfCollection) {

                    let validator = new Validator<any>().withComposedValidation(`DateOfExposure`, new ValidationEntry(Validators.requireNotFutureDate("Date of Exposure")));
                    // validator = validator.withComposedValidation(`DateOfCollection`, new ValidationEntry(Validators.requireNotFutureDate("Date of Collection")));

                    let validationResponse = validator.validate(elem);
                    if (!validationResponse.success) {
                        errorInRabies = true;
                        return sweetalert.fire({
                            icon: "error",
                            title: "",
                            text: validationResponse.error,
                        });
                    }
                }

            })

            if (errorInRabies) {
                return;
            }

            let tempRabiesExposureInfo = this.state.rabiesExposureInfo
            let invalidRabiesExposureInfo = false
            tempRabiesExposureInfo.map((info, index) => {
                if (!info.ExposedSpecies.hasOwnProperty('value') && !info.ExposureType.hasOwnProperty('value') && !info.DateOfExposure && !info.FirstName && !info.LastName && !info.phoneNumber && !info.streetAddress && !info.city && !info.state && !info.zipcode) {
                    invalidRabiesExposureInfo = false
                } else if (!info.ExposedSpecies.hasOwnProperty('value') || !info.ExposureType.hasOwnProperty('value') || !info.DateOfExposure || !info.FirstName || !info.LastName || !info.phoneNumber || !info.streetAddress || !info.city || !info.state || !info.zipcode) {
                    invalidRabiesExposureInfo = true
                } else if (info.ExposureType.value === 3 && !info.OtherExposureType) {
                    invalidRabiesExposureInfo = true
                }
            })
            if (invalidRabiesExposureInfo) {
                return sweetalert.fire({ icon: 'error', title: '', text: 'All Rabies Exposure Information fields must be filled out.' })
            }
        }

        this.setState({ showLoading: true })

        let newAnswerQuestionsObj = {}

        if (!isEmptyObject(this.state.answeredQuestionsForGetField)) {
            let answeredQuestionsArrays = Object.entries(this.state.answeredQuestionsForGetField.CustomFieldData)
            answeredQuestionsArrays.map(a => {
                return newAnswerQuestionsObj[a[0]] = a[1]
            })
        }

        let allCustomQuestions = this.props.customQuestions ? JSON.parse(JSON.stringify(this.props.customQuestions)) : [];

        
        let tempAnsweredQuestions = {}
        if (allCustomQuestions?.length > 0) {
            //remove questions that dont belong to this service
            allCustomQuestions.map((cq, i) => {
                if (!isEmptyObject(newAnswerQuestionsObj)) {
                    for (const [key, value] of Object.entries(newAnswerQuestionsObj)) {
                        if (cq.DisplayName === key) {
                            tempAnsweredQuestions[key] = value
                            break
                        }
                    }
                }

              // add generated Tracking # to answeredQuestions for Blood Lead Service (serviceID === 49)
              // add Bill Other/Bill Other Submitter based on answer to MaineCare # or Code 1
              if(this.props.service?.ID === bloodLeadServiceID) {
                if (this.props.patientInformation?.CustomFieldData) {
                  let key = 'Tracking #';
                  let value = this.generateTrackingString(
                    this.props.patientInformation?.CustomFieldData['First Name'],
                    this.props.patientInformation?.CustomFieldData["Last Name"],
                    this.props.patientInformation.CustomFieldData['Date of Birth']
                  );
                  tempAnsweredQuestions[key] = { answer: value };
                }
                // add Bill Other if MaineCare # is entered or Code 1 is checked
                if(cq.DisplayName === 'MaineCare #' && tempAnsweredQuestions[cq.DisplayName]?.answer){ //MaineCare is entered
                  tempAnsweredQuestions['Bill Other'] = { answer: 'True' }
                  tempAnsweredQuestions['Bill Other Submitter'] = { answer: 'SAMCD' }
                }
                if(cq.MetaDataFieldName === 'Code 1' && tempAnsweredQuestions['Check if patient has No Private Insurance AND No MaineCare coverage']?.answer){ // code 1 is checked
                  tempAnsweredQuestions['Bill Other'] = { answer: 'True' }
                  tempAnsweredQuestions['Bill Other Submitter'] = { answer: 'SAMCLP' }
                }
              }
              // format date fields to MM-DD-YYYY
              if(
                cq.FieldTypeID === 3 && // Date field
                tempAnsweredQuestions[cq.DisplayName] && 
                tempAnsweredQuestions[cq.DisplayName].answer && 
                tempAnsweredQuestions[cq.DisplayName].answer !== ''
              ){
                let m = moment(tempAnsweredQuestions[cq.DisplayName].answer).utc().format('MM/DD/YYYY')
                tempAnsweredQuestions[cq.DisplayName] = { answer: m }
              }
            })

            //validate questions
            let invalidCF = CustomFieldBuilder.validateCustomFields(tempAnsweredQuestions, allCustomQuestions)

            if (invalidCF) {
                this.setState({ showLoading: false })
                return
            }

            // determine if any questions are required
            let requiredQuestions = allCustomQuestions.filter(q => q.Options.isRequired);
            let hasRequiredQuestions = requiredQuestions.length > 0 ? true : false;

            if (hasRequiredQuestions && isEmptyObject(tempAnsweredQuestions)) {
                this.setState({ showLoading: false })
                return sweetalert.fire({ icon: 'error', title: '', text: `Service Specific Questions must be answered` })
            }

            // NOTE: This question is not active 
            // if Insurance or MaineCare? is True, then MaineCare # is required
            // if (tempAnsweredQuestions["Insurance or MaineCare?"] && tempAnsweredQuestions["Insurance or MaineCare?"].answer === "True") {
            //     let maineCareNum = allCustomQuestions.find(q => q.DisplayName === 'MaineCare #')
            //     if (tempAnsweredQuestions[maineCareNum.DisplayName] && tempAnsweredQuestions[maineCareNum.DisplayName].answer) {
            //         tempAnsweredQuestions[maineCareNum.DisplayName] = { answer: tempAnsweredQuestions[maineCareNum.DisplayName].answer }
            //     } else {
            //         this.setState({ showLoading: false })
            //         return sweetalert.fire({ icon: 'error', title: '', text: `MaineCare # is required` })
            //     }
            // }

            //if MaineCare # is entered must be 9 characters and end in A
            if (tempAnsweredQuestions["MaineCare #"] && tempAnsweredQuestions["MaineCare #"].answer) {
                let maineCareNum = allCustomQuestions.find(q => q.DisplayName === 'MaineCare #')
                if (tempAnsweredQuestions[maineCareNum.DisplayName].answer.length !== 9 || !tempAnsweredQuestions[maineCareNum.DisplayName].answer.endsWith('A')) {
                    this.setState({ showLoading: false })
                    return sweetalert.fire({ icon: 'error', title: '', text: `MaineCare # must be 9 characters and end in A` })
                }
            }

            //if Submitting Provider is selected/created, NPI # is required, and should be 10-digits
            if (this.state.submittingProviderLabel && this.state.submittingProviderLabel.value && this.state.submittingProviderLabel.value !== null ) {
                let npiNum = allCustomQuestions.find(q => q.DisplayName === 'NPI #')
                // Skip NPI validation when the panel has no NPI # question
                // (e.g. Salmonella PCR, Shiga Toxin, Shigella ID/serotyping).
                // Bailing here without resetting showLoading caused a forever-loading spinner.
                if (npiNum) {
                  if (tempAnsweredQuestions[npiNum.DisplayName] && tempAnsweredQuestions[npiNum.DisplayName].answer) {
                    // validate NPI # is 10 digits
                      if (!this.state.selectedProvider?.ID && (tempAnsweredQuestions[npiNum.DisplayName].answer.length !== 10 || isNaN(tempAnsweredQuestions[npiNum.DisplayName].answer))) {
                          this.setState({ showLoading: false })
                          return sweetalert.fire({ icon: 'error', title: '', text: `NPI # must be 10 digits` })
                      }
                      tempAnsweredQuestions[npiNum.DisplayName] = { answer: tempAnsweredQuestions[npiNum.DisplayName].answer }
                  } else {
                    if(this.state.selectedProvider.ID === null){
                      this.setState({ showLoading: false })
                      return sweetalert.fire({ icon: 'error', title: '', text: `NPI # is required for new providers` })
                    }
                  }
                }
                // 43JKJ1KNS
            }
        } // end if allCustomQuestions?.length > 0

        // Set Bill Other / Bill Other Submitter from doc 1 (service + specimen source)
        // and doc 2 (submitter facility). Submitter match overrides panel/specimen match.
        // Blood lead service has its own logic above and is skipped here.
        // Runs regardless of whether the service has custom questions.
        if (this.props.service?.ID !== bloodLeadServiceID) {
          const specimenSourceLabel = this.getSpecimenSourceLabel(this.state.sampleInfo?.specimenSourceID);
          const panelHCode = getPanelBillOtherHCode(this.props.service?.PanelName, specimenSourceLabel?.label);
          const submitterHCode = getSubmitterBillOtherHCode(this.props.facility?.FacilityAbbreviation);
          const hCode = submitterHCode || panelHCode;
          if (hCode) {
            tempAnsweredQuestions['Bill Other'] = { answer: 'True' }
            tempAnsweredQuestions['Bill Other Submitter'] = { answer: hCode }
          }
        }

/** CREATE PROVIDER FLOW STARTS HERE */
// create provider if new
      if (!isEmptyObject(this.state.selectedProvider) && !this.state.selectedProvider.ID) { // create provider before submit

        // on create, all fields are required
        if (!this.state.selectedProvider?.ID &&
          (isBlank(this.state.selectedProvider?.NPI_Number) || isOnlyWhitespace(this.state.selectedProvider?.NPI_Number))) {
          this.setState({ showLoading: false })
          return sweetalert.fire("Attention", "Provider NPI Number cannot be empty", "error")
        }
        else if (!this.state.selectedProvider?.ID && this.state.selectedProvider?.NPI_Number &&
          (this.state.selectedProvider?.NPI_Number.length !== 10 || isNaN(Number(this.state.selectedProvider?.NPI_Number)))) {
          this.setState({ showLoading: false })
          return sweetalert.fire("Attention", "Provider NPI Number must be 10 digits.", "error")
        }
        else if (!this.state.selectedProvider?.ID &&
          (isBlank(this.state.selectedProvider?.Address) || isOnlyWhitespace(this.state.selectedProvider?.Address))) {
          this.setState({ showLoading: false })
          return sweetalert.fire("Attention", "Provider Address cannot be empty", "error")
        }
        else if (!this.state.selectedProvider?.ID &&
          (isBlank(this.state.selectedProvider?.City) || isOnlyWhitespace(this.state.selectedProvider?.City))) {
          this.setState({ showLoading: false })
          return sweetalert.fire("Attention", "Provider City cannot be empty", "error")
        }
        else if (!this.state.selectedProvider?.ID &&
          (isBlank(this.state.selectedProvider?.State) || isOnlyWhitespace(this.state.selectedProvider?.State))) {
          this.setState({ showLoading: false })
          return sweetalert.fire("Attention", "Provider State cannot be empty", "error")
        }
        else if (!this.state.selectedProvider?.ID &&
          (isBlank(this.state.selectedProvider?.Zip) || isOnlyWhitespace(this.state.selectedProvider?.Zip))) {
          this.setState({ showLoading: false })
          return sweetalert.fire("Attention", "Provider Zip cannot be empty", "error")
        }
        else if (!this.state.selectedProvider?.ID &&
          // zip is not at least 5 digits
          (this.state.selectedProvider?.Zip.length < 5 || isNaN(Number(this.state.selectedProvider?.Zip)))
        ) {
          this.setState({ showLoading: false })
          return sweetalert.fire("Attention", "Provider Zip should be at least 5-digits", "error")
        }
        else if (!this.state.selectedProvider?.ID &&
          (isBlank(this.state.selectedProvider?.Phone) || isOnlyWhitespace(this.state.selectedProvider?.Phone))) {
          this.setState({ showLoading: false })
          return sweetalert.fire("Attention", "Provider Phone cannot be empty", "error")
        } else {

          // ensure FacilityID is set for new provider
          this.setState((prevState) => ({
            selectedProvider: {
              ...prevState.selectedProvider,
              FacilityID: this.props.facility?.ID
            }
          }), () => {
            try {
              ProviderAPI.createProvider(this.state.selectedProvider)
                .then((response) => {
                  if (!response.success) {
                    this.setState({ showLoading: false });
                    return sweetalert.fire({ icon: 'error', title: '', text: response.reason })
                  }
                  sweetalert.fire({
                    icon: 'success',
                    title: '',
                    text: `Provider ${this.state.selectedProvider.FullName} created successfully. Please click Submit to complete the form.`
                  }).then(() => {
                    this.setState((prevState) => ({
                      sampleInfo: {
                        ...prevState.sampleInfo,
                        SubmitterContactID: response.contactID
                      },
                      selectedProvider: {
                        ...prevState.selectedProvider,
                        ContactID: response.contactID,
                      },
                      submittingProviderLabel: {
                        label: this.state.selectedProvider.FullName,
                        value: response.contactID
                      },
                    }), () => {
                      // console.log(" what is state before props submit?", this.state)
                      this.props.submit({ answeredCustomQuestions: tempAnsweredQuestions, sampleType: this.props.service.SampleType, sampleInfo: this.state.sampleInfo, rabiesExposureInfo: this.state.rabiesExposureInfo })
                    });
                  })

                  // this.props.submit({ answeredCustomQuestions: tempAnsweredQuestions, sampleType: this.props.service.SampleType, sampleInfo: this.state.sampleInfo, rabiesExposureInfo: this.state.rabiesExposureInfo })

                  hideModal(ServiceFormModal.ID);
                  this.setState({ showLoading: false });
                })
            } catch (e) {
              console.error("Error creating provider", e)
              this.setState({ showLoading: false });
            }
          });
        }
        /** SUBMIT WITHOUT CREATING NEW PROVIDER */
      } else { // submit without creating a provider 
          this.props.submit({ answeredCustomQuestions: tempAnsweredQuestions, sampleType: this.props.service.SampleType, sampleInfo: this.state.sampleInfo, rabiesExposureInfo: this.state.rabiesExposureInfo })
          hideModal(ServiceFormModal.ID);
          this.setState({ showLoading: false });
        }
/** END PROVIDER LOGIC */
    }

    handleRabiesExposureUpdate(e, key, index) {
        let currentInfo = this.state.rabiesExposureInfo;
        currentInfo[index][key] = e;

        this.setState({
            rabiesExposureInfo: currentInfo
        }
        )
    }

    getServiceSpecificTests() {
        let serviceSpecificTests = []
        if (this.props.associatedTests && this.props.associatedTests.length > 0 && !isEmptyObject(this.props.service)) {
            this.props.associatedTests.map(a => {
                if (this.props.service.Tests && this.props.service.Tests.length > 0 && this.props.service.Tests.includes(a.ID)) {
                    serviceSpecificTests.push({ label: a.Name, value: a.ID })
                }
                return serviceSpecificTests;

            })
        }
        return serviceSpecificTests
    }

    getSelectedTestLabels() {
        let labels = this.state.sampleInfo?.selectedTests?.map(s => ({ label: s.Name, value: s.ID }))
        if (!labels) {
            return null
        }
        // react-select marks every entry of an array value as selected, so single-select must get a single object
        if (this.props.service && this.props.service.AllowMultipleTests) {
            return labels
        }
        return labels.length > 0 ? labels[0] : null
    }

    handleTestChange(event) {
        let selectedTestIDs = []
        let tempSelectedTestsArray = []
        if (event) {
            if (Array.isArray(event)) {
                event.map(e => {
                    selectedTestIDs.push(e.value)
                    tempSelectedTestsArray.push(this.props.associatedTests.find(q => q.ID === e.value))
                })
            }
            else {
                selectedTestIDs.push(event.value)
                tempSelectedTestsArray.push(this.props.associatedTests.find(q => q.ID === event.value))
            }

            let shortestObj
            if (tempSelectedTestsArray.length > 0) {
                shortestObj = tempSelectedTestsArray.reduce((min_obj, obj) => min_obj.ValidSpecimenSources.length < obj.ValidSpecimenSources.length ? min_obj : obj)
            }


            let validSources = [];
            shortestObj.ValidSpecimenSources.map(vss => {
                validSources.push({ label: vss.Name, value: vss.ID })
            })

            this.setState((prevState) => ({
                validSources: validSources,
                sampleInfo: {
                    ...prevState.sampleInfo,
                    selectedTests: tempSelectedTestsArray,
                    specimenSourceID: null,
                    specimenSourceOther: '',
                    isLabService: this.props.service.IsLabService,
                    serviceID: this.props.service.ID,
                    collectionDate: null
                }
            }))

        }
        else {
            this.setState((prevState) => ({
                validSources: null,
                sampleInfo: {
                    ...prevState.sampleInfo,
                    selectedTests: [],
                    specimenSourceID: null,
                    specimenSourceOther: '',
                    collectionDate: null
                }
            }))
        }
    }

    getAssociatedSources(testIDs) {
        let temp = []
        if (testIDs && testIDs.length > 0) {
            testIDs.map(t => {
                temp = temp.concat(this.props.sources.filter(s => s.value.TestID === t && s.value.IsEnabled === 1))
            })
        }
        let mappedTemp = temp.map(t => {
            return {
                label: t.label,
                value: t.value.SpecimenSourceID
            }
        })
        return mappedTemp;
    }

    showBarcodeScanner = (e) => {
        this.setState({ showScanner: true })
    }

    handleScan(scan, selectedTest) {
        if (!scan) {
            this.setState({ showScanner: false });
            return;
        }
        sweetalert.fire({
            title: "Scan Captured",
            html: "Please verify <b> " + scan.text + " </b>  matches the barcode.",
            icon: "info",
            showCancelButton: true,
            allowOutsideClick: false,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState((prevState) => ({
                    showScanner: false,
                    sampleInfo: {
                        ...prevState.sampleInfo,
                        specimenID: scan.text
                    }
                })
                )
            }
            if (result.isDismissed) {
                //keep scanner div open so user can hit Scan
                this.setState({ showScanner: true })
            }
        });
    }

    getSpecimenSourceLabel(id) {
        let specimenSourceLabel;
        this.state.validSources.map(vs => {
            if (vs.value === id) {
                specimenSourceLabel = { label: vs.label, value: id }
            }
        })
        return specimenSourceLabel
    }

    handleCollectionDateOnChange(value) {
        if (value) {
          // ensure valid date
          const dateValue = new Date(value);
          if (isNaN(dateValue.getTime())) {
            // Invalid date
            sweetalert.fire({
              icon: 'error',
              title: '',
              text: 'Please enter a valid collection date.'
            });
            return;
          }

          this.setState((prevState) => ({
            sampleInfo: {
              ...prevState.sampleInfo,
              collectionDate: value
            }
          }) as any);
        }
        else {
            this.setState((prevState) => ({
                sampleInfo: {
                    ...prevState.sampleInfo,
                    collectionDate: null
                }
            }) as any);
        }
    }

    removeRabiesInfoEntry(index) {
        let temp = this.state.rabiesExposureInfo
        temp.splice(index, 1)
        this.setState({ rabiesExposureInfo: temp })
    }

    getDateForInput(date) {
        if (typeof date === 'string') {
            return date
        } else {
            return moment(date).format('YYYY-MM-DDTHH:mm')
        }
    }

    clearNPIFieldOnForm = (e) => {
      // console.log(" clearNPIFieldOnForm", e)
      const newItems = { ...this.state.answeredQuestionsForGetField?.CustomFieldData };
      delete newItems["NPI #"]; // delete will do nothing if NPI # doesn't exist

      this.setState((prevState) => ({
        answeredQuestionsForGetField: {
          ...prevState.answeredQuestionsForGetField,
          CustomFieldData: newItems
        }
      }));
    }

    async handleCreateSubmittingProvider(e) {
      // console.log(" handleCreateSubmittingProvider", e) // e is the full name of the provider
      // if user selected a provider with an npi #, we need to clear the field
      // to ensure new provider doesn't share NPI # 
      // const clearNPIFieldOnForm = (e) => {
      //   // console.log(" clearNPIFieldOnForm", e)
      //   const newItems = { ...this.state.answeredQuestionsForGetField?.CustomFieldData };
      //   delete newItems["NPI #"]; // delete will do nothing if NPI # doesn't exist

      //   this.setState((prevState) => ({
      //     answeredQuestionsForGetField: {
      //       ...prevState.answeredQuestionsForGetField,
      //       CustomFieldData: newItems
      //     }
      //   }));
      // }
      this.clearNPIFieldOnForm(e);

      let userinput = e;
      try{
        // const reversedFullName = await reverseFullName(userinput);

        let nameParts = userinput.trim().split(/\s+/);
        if (nameParts.length === 1) {
          throw new Error("Invalid full name format. Please provide the Last and First name of the Provider.");
        }

        let existsByFullName = this.props.submittingProviders?.find(p => (p.FullName) === (userinput).toUpperCase())
        // let found = this.props.submittingProviders?.find(p => p.NPI_Number === this.state.selectedProvider?.NPI_Number)
        // console.log(" found?", found);
        if (existsByFullName && existsByFullName.ContactID && existsByFullName.ContactID === (userinput).toUpperCase()) {
          // selected a 'new' provider that does not have a valid contact ID yet...
          sweetalert.fire({icon: 'warning', title: 'Attention', text: "Provider data needs to sync with Starlims before submission can be posted successfully. Please reach out to HETL with any questions"})
        } else if (existsByFullName && existsByFullName.ContactID && existsByFullName.ContactID !== (userinput).toUpperCase()) {
          // selected an existing provider that has a valid contact ID
          sweetalert.fire({icon: 'info', title: 'Attention', text: "Provider already exists for the selected Facility"})
        } else {
          sweetalert.fire({icon: 'info', title: 'Attention', text: "Please add NPI # and contact information for new providers. If you do not have this information, please select an existing provider."})
        }

        this.setState((prevState) => ({
          // sampleInfo: {
          //   ...prevState.sampleInfo,
          //   // SubmitterContactID: reversedFullName // this should be the contactID  - figure out how to create without needing user to close modal
          // },
          submittingProviderLabel: { label: userinput, value: userinput },
          selectedProvider: {
            ...prevState.selectedProvider,
            FullName: userinput.trim().toUpperCase()
          },
        }));
      }catch(e){
        sweetalert.fire({ icon: 'error', title: '', text: e.message});
        return;
      }
    }

    async handleSubmittingProviderChange(e) {
    //   // console.log(" handleSubmittingProviderChange", e)
      if(!e || !e.value) {
        this.clearNPIFieldOnForm(e);
        // clear the dropdown
        this.setState((prevState) => ({
          sampleInfo: {
            ...prevState.sampleInfo,
            SubmitterContactID: null
          },
          submittingProviderLabel: { label: "", value: null},
          selectedProvider: {} as SubmittingProvider, 
          providerSearchAddress: ""
        }))
      } else {
        // find ContactID in submittingProviders via e.value
        const selected = this.props.submittingProviders?.find(p => p.ID === e.value)
        // let reversedFullName = await reverseFullName(e.label);
        if (selected && selected.ContactID && selected.ContactID === (e.label).toUpperCase()) {
          // selected a 'new' provider that does not have a valid contact ID yet...
          sweetalert.fire({icon: 'warning', title: 'Attention', text: "This Provider's Contact_ID data needs to sync with Starlims before submission can be posted successfully. Please reach out to HETL with any questions"})
        }

        let npiNum = selected?.NPI_Number ? selected.NPI_Number : "";

        this.setState((prevState) => ({
          sampleInfo: {
            ...prevState.sampleInfo,
            SubmitterContactID: selected.ContactID
          },
          answeredQuestionsForGetField: {
            ...prevState.answeredQuestionsForGetField,
            CustomFieldData: {
              ...(prevState.answeredQuestionsForGetField?.CustomFieldData || {}),
              ["NPI #"]: { answer: npiNum } // pre-populate NPI # field
            }
          },
          submittingProviderLabel: { label: e.label, value: e.value },
          selectedProvider: selected 
        }))
      }
    }


    render() {

        // console.log('state in ServiceForm', this.state)
        // console.log('props in ServiceForm', this.props)
        // let specIDString = this.props.service && (this.props.service.IsLabService && !this.props.service.SampleType) ? "Accession ID" : "Accession ID (optional)"
        let specIDString = "Accession ID (optional)";

        return (
            <React.Fragment>
                <Overlay show_loading={this.state.showLoading} zIndex={100005} />
                <div className="modal fade form_modal" id={ServiceFormModal.ID} tabIndex={-1} role="dialog"
                    aria-label="Service Related Questions"
                    aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-body p-0 m-0">
                                <div className="container-fluid">
                                    <div className={"row"}>
                                        <div className="col-12 pt-2">
                                            <div className="card mb-2">
                                                <div className="card-header verlag-bold">
                                                    <div className="row">
                                                        <div className="col-10">
                                                            <h4>
                                                                {this.props.service && this.props.service.Name}
                                                            </h4>
                                                        </div>
                                                        <div className="col-2">
                                                            <button style={{ outline: 'none' }} type="button" className="close pr-4"
                                                                aria-label="close" onClick={() => hideModal(ServiceFormModal.ID)}>
                                                                <span aria-hidden="true" style={{ fontSize: '1.5em', fontWeight: 'bold' }}>&times;</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    {this.props.customQuestions?.length > 0 ?
                                                        <div className="card mb-2">
                                                            <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#serviceCollapse" onClick={() => this.setState({ serviceArrowDown: !this.state.serviceArrowDown })} aria-expanded="false" aria-controls="serviceCollapse">
                                                                <div className="row d-flex justify-content-between">
                                                                    <div className="">
                                                                        <h4>Questionnaire</h4>
                                                                    </div>
                                                                    <div className="col-2">
                                                                        {this.state.serviceArrowDown ? (<AiOutlineUp className={'float-right'} size={30} data-toggle="collapse" data-target="#serviceCollapse" role="button" aria-expanded="false" aria-controls="serviceCollapse" />) : (<AiOutlineDown className={'float-right'} size={30} data-toggle="collapse" data-target="#serviceCollapse" role="button" aria-expanded="false" aria-controls="serviceCollapse" />)}
                                                                    </div>
                                                                </div>
                                                            </button>
                                                            <div className="card-body collapse show" id={'serviceCollapse'}>
                                                                <div className="row">
                                                                    {this.props.customQuestions.map((val, index) => {
                                                                        if (val.Options.isActive && val.DisplayName !== 'NPI #') { {/* NPI displays under Submitting Provider in Sample Info*/}
                                                                          return (
                                                                            <div className="col-12">
                                                                              <div className="form-group row">
                                                                                <GetField
                                                                                  val={val}
                                                                                  isRequired={val.Options.isRequired}
                                                                                  readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)}
                                                                                  selectedItem={this.state.answeredQuestionsForGetField ? this.state.answeredQuestionsForGetField : null}
                                                                                  handleChange={(e) => {
                                                                                    this.setState({ answeredQuestionsForGetField: e })
                                                                                  }}
                                                                                />
                                                                              </div>
                                                                            </div>
                                                                          )
                                                                        }
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className='d-none'></div>

                                                    }
                                                    {this.props.showSampleInfo &&
                                                        <div className="card mb-2">
                                                            <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#walkinSampleInfoCollapse" onClick={() => this.setState({ walkinSampleInfoArrowDown: !this.state.walkinSampleInfoArrowDown })} aria-expanded="false" aria-controls="walkinSampleInfoCollapse">
                                                                <div className="row d-flex justify-content-between">
                                                                    <div className="">
                                                                        <h4>Sample Information</h4>
                                                                    </div>
                                                                    <div className="col-2">
                                                                        {this.state.walkinSampleInfoArrowDown ? (<AiOutlineUp className={'float-right'} size={30} data-toggle="collapse" data-target="#walkinSampleInfoCollapse" role="button" aria-expanded="false" aria-controls="walkinSampleInfoCollapse" />) : (<AiOutlineDown className={'float-right'} size={30} data-toggle="collapse" data-target="#walkinSampleInfoCollapse" role="button" aria-expanded="false" aria-controls="walkinSampleInfoCollapse" />)}
                                                                    </div>
                                                                </div>
                                                            </button>


                                                            <div className="card-body collapse show" id={'walkinSampleInfoCollapse'}>

                                                                <div className="form-group row" >
                                                                    <label id="testTypeLabel" htmlFor="testType" className="col-sm-4 col-form-label">Test Type</label>
                                                                    <div className="col-sm-8  p-0 m-0" tabIndex={0} aria-labelledby="TestType testTypeLabel">
                                                                        <Select
                                                                            id="TestType"
                                                                            name="testType"
                                                                            aria-label={"Test Type"}
                                                                            isMulti={!!(this.props.service && this.props.service.AllowMultipleTests)}
                                                                            isDisabled={true}
                                                                            isSearchable={true}
                                                                            placeholder={<div className="accessibilityText">Please Select...</div>}
                                                                            noOptionsMessage={() => "No option"}
                                                                            className={"state_select"}
                                                                            options={this.getServiceSpecificTests()}
                                                                            onChange={(e) => this.handleTestChange(e)}
                                                                            value={this.getSelectedTestLabels()}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                { this.props.service?.ID === bloodLeadServiceID &&
                                                                  <div className="form-group row" >
                                                                      <label id="trackingLabel" htmlFor="trackingNum" className="col-sm-4 col-form-label">Tracking #</label>
                                                                      <div className="col-sm-8  p-0 m-0" tabIndex={0} aria-labelledby="TestType testTypeLabel">
                                                                          <input
                                                                              id="TrackingNum"
                                                                              name="trackingNum"
                                                                              aria-label={"Tracking #"}
                                                                              readOnly={true}
                                                                              className={"form-control"}
                                                                              value={
                                                                                !isEmptyObject(this.props.patientInformation?.CustomFieldData) ? 
                                                                                this.generateTrackingString(
                                                                                  this.props.patientInformation?.CustomFieldData['First Name'], 
                                                                                  this.props.patientInformation?.CustomFieldData["Last Name"], 
                                                                                  this.props.patientInformation.CustomFieldData['Date of Birth']
                                                                                ) : 
                                                                                '' 
                                                                              }
                                                                          />
                                                                      </div>
                                                                  </div>
                                                                }
                                                                <div className="form-group row">
                                                                    <label id="collectionDateLabel" htmlFor={'collectionDate'} className="col-sm-4 col-form-label">Collection Date<section className="text-danger d-inline-block px-1">*</section></label>
                                                                    <div className={"col-sm-8 p-0 m-0 "} aria-labelledby="collectionDateInput collectionDateLabel">
                                                                        <input
                                                                            id={'collectionDateInput'}
                                                                            disabled={false}
                                                                            readOnly={false}
                                                                            aria-labelledby={'collectionDateInput'}
                                                                            className={"form-control"}
                                                                            autoComplete={"off"}
                                                                            type={"datetime-local"}
                                                                            min={"1970-01-01T00:00"}
                                                                            onChange={(e) => {
                                                                                this.handleCollectionDateOnChange(e.target.value)
                                                                            }}
                                                                            value={this.getDateForInput(this.state.sampleInfo?.collectionDate)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group row">
                                                                    {/* <label htmlFor={"SpecimenID"} className={"col-sm-4 col-form-label"}>{specIDString}{this.props.service && (this.props.service.IsLabService && !this.props.service.SampleType) ? <section className="text-danger d-inline-block px-1">*</section> : ""}</label> */}
                                                                    <label htmlFor={"SpecimenID"} className={"col-sm-4 col-form-label"}>{specIDString}</label>
                                                                    <div className={"col-sm-8 p-0 m-0 input-group"}>
                                                                        <button className={"btn btn-primary btn-sm"}
                                                                            onClick={this.showBarcodeScanner}
                                                                            aria-label="Scan Accession ID"
                                                                            disabled={!this.state.sampleInfo?.selectedTests || this.state.sampleInfo?.selectedTests?.length < 1}
                                                                        ><FaCameraRetro /></button>
                                                                        <input type={"search"} className="form-control" id={"AccessionID"}
                                                                            value={this.state.sampleInfo?.specimenID}
                                                                            autoComplete="off"
                                                                            onChange={(e) => {
                                                                                this.setState((prevState) => ({
                                                                                    sampleInfo: {
                                                                                        ...prevState.sampleInfo,
                                                                                        specimenID: e.target.value,
                                                                                    }
                                                                                }))
                                                                            }}
                                                                            disabled={!this.state.sampleInfo?.selectedTests || this.state.sampleInfo?.selectedTests?.length < 1}
                                                                            maxLength={50}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {this.state.showScanner ?
                                                                    <BarcodeScannerComponent
                                                                        onResult={this.handleScan}
                                                                        showButtons={true}
                                                                        started={false}
                                                                    />
                                                                    : null
                                                                }
                                                                {/* <div className="form-group row">
                                                                    <label htmlFor={"Lot"} className={"col-sm-4 col-form-label"}>Lot (optional)</label>
                                                                    <div className={"col-sm-8 p-0 m-0 "}>
                                                                        <input type={"search"} className="form-control" id={"Lot"}
                                                                            value={this.state.sampleInfo?.lot}
                                                                            autoComplete="off"
                                                                            onChange={(e) => {
                                                                                this.setState((prevState) => ({
                                                                                    sampleInfo: {
                                                                                        ...prevState.sampleInfo,
                                                                                        lot: e.target.value,
                                                                                    }
                                                                                }))
                                                                            }}
                                                                            maxLength={45}
                                                                        />
                                                                    </div>
                                                                </div> */}

                                                                <div className="form-group row">
                                                                    <label htmlFor={'Specimen Source'} className="col-sm-4 col-form-label">Specimen Source<section className="text-danger d-inline-block px-1">*</section></label>
                                                                    <div className="col-sm-8  p-0 m-0" id={'Specimen Source'}>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            aria-label={"Specimen Source"}
                                                                            placeholder={<div className="accessibilityText">Please Select...</div>}
                                                                            noOptionsMessage={() => "No option"}
                                                                            className={"state_select"}
                                                                            isDisabled={!this.state.sampleInfo?.selectedTests || this.state.sampleInfo?.selectedTests?.length < 1}
                                                                            options={this.state.validSources}
                                                                            onChange={(e) => {
                                                                                this.setState((prevState) => ({
                                                                                    sampleInfo: {
                                                                                        ...prevState.sampleInfo,
                                                                                        specimenSourceID: e.value
                                                                                    }
                                                                                })
                                                                                )
                                                                            }
                                                                            }

                                                                            value={this.state.sampleInfo && this.state.sampleInfo.specimenSourceID ? this.getSpecimenSourceLabel(this.state.sampleInfo.specimenSourceID) : null}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {/* {this.state.sampleInfo.specimenSourceID === 8 &&
                                                                    <div className="form-group row">
                                                                        <label htmlFor={'Specimen Source Other'} className="col-sm-4 col-form-label">Other Specimen Source</label>
                                                                        <div className="col-sm-8  p-0 m-0" id={'Specimen Source Other'}>
                                                                            <input type={"search"} className="form-control" id={"Specimen Source Other"}
                                                                                value={this.state.sampleInfo?.specimenSourceOther}
                                                                                autoComplete="off"
                                                                                onChange={(e) => {
                                                                                    this.setState((prevState) => ({
                                                                                        sampleInfo: {
                                                                                            ...prevState.sampleInfo,
                                                                                            specimenSourceOther: e.target.value
                                                                                        }
                                                                                    })
                                                                                    )
                                                                                }
                                                                                }
                                                                                disabled={this.state.sampleInfo?.specimenSourceID ? false : true}
                                                                                maxLength={80}
                                                                            />
                                                                        </div>
                                                                    </div>} */}
                                                                {/* {this.props?.service?.ID === 3 ? <div className="form-group row">
                                                                    <label htmlFor={"Lot"} className={"col-sm-4 col-form-label"}>Collection Location of Specimen (Body site)</label>
                                                                    <div className={"col-sm-8 p-0 m-0 "}>
                                                                        <input type={"search"} className="form-control" id={"bodySite"}
                                                                            value={this.state.sampleInfo?.bodySite}
                                                                            autoComplete="off"
                                                                            onChange={(e) => {
                                                                                this.setState((prevState) => ({
                                                                                    sampleInfo: {
                                                                                        ...prevState.sampleInfo,
                                                                                        bodySite: e.target.value,
                                                                                    }
                                                                                }))
                                                                            }}
                                                                            maxLength={45}
                                                                        />
                                                                    </div>
                                                                </div> : <></>} */}
                                                                <div className="form-group row">
                                                                    <label htmlFor={"Memo"} className={"col-sm-4 col-form-label pb-0"}>
                                                                        <p className="mb-0">Memo (optional)</p>
                                                                    </label>
                                                                    <div className={"col-sm-8 p-0 m-0 "}>
                                                                        <textarea
                                                                            id={"Memo"}
                                                                            rows={3}
                                                                            maxLength={1000}
                                                                            className={'form-control'}
                                                                            value={this.state.sampleInfo?.memo}
                                                                            autoComplete="off"
                                                                            onChange={(e) => {
                                                                                this.setState((prevState) => ({
                                                                                    sampleInfo: {
                                                                                        ...prevState.sampleInfo,
                                                                                        memo: e.target.value
                                                                                    }
                                                                                })
                                                                                )
                                                                            }
                                                                            }

                                                                        />
                                                                        <div className={this.state.sampleInfo?.memo && this.state.sampleInfo?.memo.length > 0 ? 'visible float-right' : 'invisible'}>
                                                                            <div style={{ fontSize: '0.8em' }}>{this.state.sampleInfo?.memo && this.state.sampleInfo.memo?.length}/1000</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {this.props.service?.SampleType === 1 &&
                                                                    <div className="form-group row">
                                                                        <label htmlFor={'Animal Type'} className="col-sm-4 col-form-label">Animal Type</label>
                                                                        <div className="col-sm-8  p-0 m-0" id={'Animal Type'}>
                                                                            <Select
                                                                                isSearchable={true}
                                                                                aria-label={"Animal Type"}
                                                                                placeholder={<div className="accessibilityText">Please Select...</div>}
                                                                                noOptionsMessage={() => "No option"}
                                                                                className={"state_select"}
                                                                                options={this.props.animalTypes}
                                                                                onChange={(e) => {
                                                                                    this.setState((prevState) => ({
                                                                                        sampleInfo: {
                                                                                            ...prevState.sampleInfo,
                                                                                            animalType: e.value
                                                                                        }
                                                                                    })
                                                                                    )
                                                                                }
                                                                                }

                                                                                value={this.state.sampleInfo && this.state.sampleInfo.animalType ? getLabel(this.state.sampleInfo.animalType, this.props.animalTypes) : null}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                                { this.state.sampleInfo?.animalType === this.props.animalTypes.length &&
                                                                    <div className="form-group row">
                                                                        <label htmlFor={'Other Animal Type'} className="col-sm-4 col-form-label">Other Animal Type</label>
                                                                        <div className="col-sm-8  p-0 m-0" id={'Other Animal Type'}>
                                                                            <input type={"search"} className="form-control" id={"Other Animal Type"}
                                                                                value={this.state.sampleInfo?.otherAnimalType}
                                                                                autoComplete="off"
                                                                                onChange={(e) => {
                                                                                    this.setState((prevState) => ({
                                                                                        sampleInfo: {
                                                                                            ...prevState.sampleInfo,
                                                                                            otherAnimalType: e.target.value
                                                                                        }
                                                                                    })
                                                                                    )
                                                                                }
                                                                                }
                                                                                maxLength={80}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                        {/* Show Provider accordion here */}
                                                    { this.props.showProviderInfo &&
                                                      <div className="card mb-2">
                                                        <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#providerCollapse" 
                                                                onClick={() => this.setState({ providerArrowDown: !this.state.providerArrowDown })} aria-expanded="false" aria-controls="providerCollapse">
                                                          <div className="row d-flex justify-content-between">
                                                            <div className="">
                                                              <h4>Provider Information</h4>
                                                            </div>
                                                            <div className="col-2">
                                                              {this.state.providerArrowDown ? (<AiOutlineUp className={'float-right'} size={30} data-toggle="collapse" data-target="#providerCollapse" role="button" aria-expanded="false" aria-controls="providerCollapse" />) : (<AiOutlineDown className={'float-right'} size={30} data-toggle="collapse" data-target="#providerCollapse" role="button" aria-expanded="false" aria-controls="providerCollapse" />)}
                                                            </div>
                                                          </div>
                                                        </button>
                                                        <div className="card-body collapse show" id={'providerCollapse'}>
                                                          <div className="form-group-row">
                                                            <div className="form-group row">
                                                              <label htmlFor={'Submitting Provider'} className="col-sm-4 col-form-label">
                                                                Provider Full Name (NPI#) <section className="text-danger d-inline-block px-1">*</section>
                                                              </label>
                                                              <div className={"col-sm-8 p-0 m-0"}>
                                                                <CreatableSelect
                                                                  id={'Submitting Provider'}
                                                                  name="Submitting Provider"
                                                                  backspaceRemovesValue={true}
                                                                  escapeClearsValue={true}
                                                                  isSearchable={true}
                                                                  isClearable={true}
                                                                  aria-label={"Submitting Provider"}
                                                                  placeholder={<div className="accessibilityText">Please Select... Last First MI (NPI #) </div>}
                                                                  noOptionsMessage={({ inputValue }) => `No result found for "${inputValue}"`}
                                                                  className={"state_select"}
                                                                  options={this.props.providerSelectOptions}
                                                                  onChange={(e) => this.handleSubmittingProviderChange(e)}
                                                                  onCreateOption={(e) => this.handleCreateSubmittingProvider(e) }
                                                                  value={this.state.submittingProviderLabel}
                                                                />
                                                                <small className="form-text text-muted" style={{ paddingLeft: "1em" }}>Last First MI</small>
                                                              </div>
                                                            </div>
                                      {/* Show these fields for new provider */}
                                      {this.state.selectedProvider && !this.state.selectedProvider?.ID &&
                                        this.state.submittingProviderLabel && this.state.submittingProviderLabel.value != null &&
                                        <>
                                          {/* NPI field is required only if we created a new provider */}
                                          <div className={"form-group row"}>
                                            {this.props.customQuestions?.map((val, index) => {
                                              if (val.Options.isActive && val.DisplayName === 'NPI #') {
                                                return (
                                                  <div className="col-12">
                                                    <div className="form-group row">
                                                      <GetField
                                                        val={val}
                                                        isRequired={val.Options.isRequired || !this.state.selectedProvider?.ID}
                                                        readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)}
                                                        selectedItem={this.state.answeredQuestionsForGetField ? this.state.answeredQuestionsForGetField : null}
                                                        handleChange={(e) => this.handleNPIChange(e)}
                                                      />
                                                    </div>
                                                  </div>
                                                )
                                              }
                                            })}
                                          </div>

                                          <div className="form-group row">
                                            <label htmlFor={'SearchAddress'} className="col-sm-4 col-form-label">Search Address</label>
                                            <div className="col-sm-8  p-0 m-0" id={'SearchAddress'}>
                                              <AutoComplete key={`ProviderAddressautocomplete`} id={`ProviderAddressautocomplete`}
                                                onChange={(addr) => {
                                                  this.setState((prevState) => ({ providerSearchAddress: addr }))
                                                }}
                                                value={this.state.providerSearchAddress}
                                                updateFormData={(addr, addr2, city, state, zip, county, country) => {
                                                  let addressData = { Address: "", Address_A: "", City: "", State: "", Zip: "" };
                                                  addressData.Address = addr;
                                                  addressData.Address_A = addr2;
                                                  addressData.City = city;
                                                  addressData.State = state;
                                                  addressData.Zip = zip;
                                                  this.setState({ selectedProvider: { ...this.state.selectedProvider, ...addressData } })
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <div className="form-group row">
                                            <label htmlFor={'Provider Address'} className="col-sm-4 col-form-label">Provider Address<section className="text-danger d-inline-block px-1">*</section></label>
                                            <div className={"col-sm-8 p-0 m-0"}>
                                              <input
                                                id={'Provider Address'}
                                                name="Provider Address"
                                                aria-label={"Provider Address"}
                                                className={"form-control"}
                                                autoComplete={"off"}
                                                type={"text"}
                                                value={this.state.selectedProvider?.Address ? this.state.selectedProvider?.Address : ""}
                                                onChange={(e) => {
                                                  this.setState((prevState) => ({
                                                    selectedProvider: {
                                                      ...prevState.selectedProvider,
                                                      Address: e.target.value
                                                    }
                                                  }))
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <div className="form-group row">
                                            <label htmlFor={'Provider AddressA'} className="col-sm-4 col-form-label">Provider Address Cont.</label>
                                            <div className={"col-sm-8 p-0 m-0"}>
                                              <input
                                                id={'Provider AddressA'}
                                                name="Provider AddressA"
                                                aria-label={"Provider AddressA"}
                                                className={"form-control"}
                                                autoComplete={"off"}
                                                type={"text"}
                                                value={this.state.selectedProvider?.Address_A ? this.state.selectedProvider?.Address_A : ""}
                                                onChange={(e) => {
                                                  this.setState((prevState) => ({
                                                    selectedProvider: {
                                                      ...prevState.selectedProvider,
                                                      Address_A: e.target.value
                                                    }
                                                  }))
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <div className="form-group row">
                                            <label htmlFor={'Provider City'} className="col-sm-4 col-form-label">Provider City<section className="text-danger d-inline-block px-1">*</section></label>
                                            <div className={"col-sm-8 p-0 m-0"}>
                                              <input
                                                id={'Provider City'}
                                                name="Provider City"
                                                aria-label={"Provider City"}
                                                className={"form-control"}
                                                autoComplete={"off"}
                                                type={"text"}
                                                value={this.state.selectedProvider?.City ? this.state.selectedProvider?.City : ""}
                                                onChange={(e) => {
                                                  this.setState((prevState) => ({
                                                    selectedProvider: {
                                                      ...prevState.selectedProvider,
                                                      City: e.target.value
                                                    }
                                                  }))
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <div className="form-group row">
                                            <label htmlFor={'Provider State'} className="col-sm-4 col-form-label">Provider State<section className="text-danger d-inline-block px-1">*</section></label>
                                            <div className={"col-sm-8 p-0 m-0"}>
                                              <Select
                                                key={'Provider State'}
                                                id={'Provider State'}
                                                name="Provider State"
                                                isSearchable={true}
                                                placeholder={<div className="accessibilityText">Please Select...</div>}
                                                aria-label={"Provider State"}
                                                className={"state_select"}
                                                options={this.props.states}
                                                value={this.state.selectedProvider.State ? getLabel(this.state.selectedProvider.State, this.props.states) : null}
                                                onChange={(e) => {
                                                  this.setState((prevState) => ({
                                                    selectedProvider: {
                                                      ...prevState.selectedProvider,
                                                      State: e.value
                                                    }
                                                  }))
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <div className="form-group row">
                                            <label htmlFor={'Provider Zip'} className="col-sm-4 col-form-label">Provider Zip<section className="text-danger d-inline-block px-1">*</section></label>
                                            <div className={"col-sm-8 p-0 m-0"}>
                                              <input
                                                id={'Provider Zip'}
                                                name="Provider Zip"
                                                aria-label={"Provider Zip"}
                                                className={"form-control"}
                                                autoComplete={"off"}
                                                type={"text"}
                                                value={this.state.selectedProvider?.Zip ? this.state.selectedProvider?.Zip : ""}
                                                onChange={(e) => {
                                                  this.setState((prevState) => ({
                                                    selectedProvider: {
                                                      ...prevState.selectedProvider,
                                                      Zip: e.target.value
                                                    }
                                                  }))
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <div className="form-group row">
                                            <label htmlFor={'Provider Phone'} className="col-sm-4 col-form-label">Provider Phone<section className="text-danger d-inline-block px-1">*</section></label>
                                            <div className={"col-sm-8 p-0 m-0"}>
                                              <PhoneInput
                                                name={`Provider Phone`}
                                                id={'Provider Phone'}
                                                placeholder="Enter phone number"
                                                value={this.state.selectedProvider?.Phone ? this.state.selectedProvider?.Phone : ""}
                                                defaultCountry="US"
                                                onChange={(e) => {
                                                  this.setState((prevState) => ({
                                                    selectedProvider: {
                                                      ...prevState.selectedProvider,
                                                      Phone: e
                                                    }
                                                  }))
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </>
                                      }
                                                          </div>
                                                        </div>
                                                      </div>
                                                    }
                                                    {/* end Provider Information */}
                                                    {this.props.service?.ID === rabiesServiceID &&
                                                        <div className="card mb-2">
                                                            <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#walkinRabiesExposureInfoCollapse" onClick={() => this.setState({ walkinRabiesExposureInfoArrowDown: !this.state.walkinRabiesExposureInfoArrowDown })} aria-expanded="false" aria-controls="walkinRabiesExposureInfoCollapse">
                                                                <div className="row d-flex justify-content-between">
                                                                    <div className="">
                                                                        <h4>Rabies Exposure Information</h4>
                                                                    </div>
                                                                    <div className="col-2">
                                                                        {this.state.walkinRabiesExposureInfoArrowDown ? (<AiOutlineUp className={'float-right'} size={30} data-toggle="collapse" data-target="#walkinRabiesExposureInfoCollapse" role="button" aria-expanded="false" aria-controls="walkinRabiesExposureInfoCollapse" />) : (<AiOutlineDown className={'float-right'} size={30} data-toggle="collapse" data-target="#walkinRabiesExposureInfoCollapse" role="button" aria-expanded="false" aria-controls="walkinRabiesExposureInfoCollapse" />)}
                                                                    </div>
                                                                </div>
                                                            </button>
                                                            <div className="card-body collapse show" id={'walkinRabiesExposureInfoCollapse'}>
                                                                {this.state.rabiesExposureInfo.length > 0 ? this.state.rabiesExposureInfo.map((info, index) => {
                                                                    return (
                                                                        <>
                                                                            {index > 0 && <hr />}
                                                                            {index > 0 && <div className="d-flex justify-content-end align-content-center">
                                                                                <button style={{ outline: 'none' }} type="button" className="close"
                                                                                    aria-label="Remove School/ Child Care" onClick={() => this.removeRabiesInfoEntry(index)}>
                                                                                    <span aria-hidden="true" className='d-inline-block pb-3 mr-3' style={{ fontSize: '1.5em', fontWeight: 'bold', color: "#B30000" }}>&times;</span>
                                                                                </button>
                                                                            </div>}
                                                                            <div className="form-group row" >
                                                                                <label id="exposureSourceLabel" htmlFor="exposedSpecies" className="col-sm-4 col-form-label">Exposed Species</label>
                                                                                <div className="col-sm-8  p-0 m-0" tabIndex={0} aria-labelledby="exposedSpecies exposureSourceLabel">
                                                                                    <Select
                                                                                        id="exposedSpecies"
                                                                                        name="exposedSpecies"
                                                                                        aria-label={"Exposed Species"}
                                                                                        isSearchable={true}
                                                                                        placeholder={<div className="accessibilityText">Please Select...</div>}
                                                                                        noOptionsMessage={() => "No option"}
                                                                                        className={"state_select"}
                                                                                        options={[{ label: "Human", value: 1 }, { label: "Animal", value: 2 }]}
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e, 'ExposedSpecies', index)
                                                                                        }}
                                                                                        value={this.state.rabiesExposureInfo && this.state.rabiesExposureInfo[index].ExposedSpecies ? this.state.rabiesExposureInfo[index].ExposedSpecies : null}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor={'FirstName'} className="col-sm-4 col-form-label">{this.state.rabiesExposureInfo[index].ExposedSpecies.value !== 2 ? 'First Name' : "Owner First Name"}</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'FirstName'}>
                                                                                    <input type={"search"} className="form-control" id={"FirstName"}
                                                                                        value={this.state.rabiesExposureInfo[index].FirstName}
                                                                                        autoComplete="off"
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e.target.value, 'FirstName', index)
                                                                                        }
                                                                                        }
                                                                                        maxLength={80}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor={'LastName'} className="col-sm-4 col-form-label">{this.state.rabiesExposureInfo[index].ExposedSpecies.value !== 2 ? 'Last Name' : "Owner Last Name"}</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'LastName'}>
                                                                                    <input type={"search"} className="form-control" id={"LastName"}
                                                                                        value={this.state.rabiesExposureInfo[index].LastName}
                                                                                        autoComplete="off"
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e.target.value, 'LastName', index)
                                                                                        }
                                                                                        }
                                                                                        maxLength={80}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor={'SearchAddress'} className="col-sm-4 col-form-label">Search Address</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'SearchAddress'}>
                                                                                    <AutoComplete key={`Exposureautocomplete${index}`} id={`Exposureautocomplete${index}`}
                                                                                        onChange={(addr) => {
                                                                                            let currentInfo = this.state.rabiesExposureInfo;
                                                                                            currentInfo[index].searchAddress = addr;
                                                                                            this.setState((prevState) => ({ rabiesExposureInfo: currentInfo }))
                                                                                        }}
                                                                                        value={this.state.rabiesExposureInfo[index].searchAddress}
                                                                                        updateFormData={(addr, addr2, city, state, zip, county, country) => {
                                                                                            let currentInfo = this.state.rabiesExposureInfo;
                                                                                            currentInfo[index].streetAddress = addr;
                                                                                            currentInfo[index].city = city;
                                                                                            currentInfo[index].state = state;
                                                                                            currentInfo[index].zipcode = zip;
                                                                                            this.setState({ rabiesExposureInfo: currentInfo })
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor={'streetAddress'} className="col-sm-4 col-form-label">Street Address</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'streetAddress'}>
                                                                                    <input type={"search"} className="form-control" id={"streetAddress"}
                                                                                        value={this.state.rabiesExposureInfo[index].streetAddress}
                                                                                        autoComplete="off"
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e.target.value, 'streetAddress', index)
                                                                                        }
                                                                                        }
                                                                                        maxLength={80}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor={'city'} className="col-sm-4 col-form-label">City</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'city'}>
                                                                                    <input type={"search"} className="form-control" id={"city"}
                                                                                        value={this.state.rabiesExposureInfo[index].city}
                                                                                        autoComplete="off"
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e.target.value, 'city', index)
                                                                                        }
                                                                                        }
                                                                                        maxLength={80}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor={'state'} className="col-sm-4 col-form-label">State</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'state'}>
                                                                                    <Select
                                                                                        key={'State'}
                                                                                        id={'State'}
                                                                                        isSearchable={true}
                                                                                        placeholder={<div className="accessibilityText">{"Please Select..."}</div>}
                                                                                        noOptionsMessage={() => "No option"}
                                                                                        aria-label={"State"}
                                                                                        value={this.state.rabiesExposureInfo[index] ? getLabel(this.state.rabiesExposureInfo[index].state, this.props.states) : null}
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e.value, 'state', index)
                                                                                        }}
                                                                                        className={'state_select'}
                                                                                        options={this.props.states}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor={'zip'} className="col-sm-4 col-form-label">Zipcode</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'zip'}>
                                                                                    <input type={"search"} className="form-control" id={"LastName"}
                                                                                        value={this.state.rabiesExposureInfo[index].zipcode}
                                                                                        autoComplete="off"
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e.target.value, 'zipcode', index)
                                                                                        }
                                                                                        }
                                                                                        maxLength={80}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className="form-group row">
                                                                                <label htmlFor="phoneNumber" className="col-sm-4 col-form-label">Phone Number</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'PhoneNumber'}>
                                                                                    <PhoneInput
                                                                                        name={`PhoneNumber`}
                                                                                        id={'PhoneNumber'}
                                                                                        placeholder="Enter phone number"
                                                                                        value={this.state.rabiesExposureInfo[index].phoneNumber}
                                                                                        defaultCountry="US"
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e, 'phoneNumber', index)
                                                                                        }}

                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor="dateOfExposure" className="col-sm-4 col-form-label">Date of Exposure</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'DateOfExposure'}>
                                                                                    <input
                                                                                        className={"form-control"}
                                                                                        autoComplete={"off"}
                                                                                        type={"date"}
                                                                                        value={this.state.rabiesExposureInfo[index].DateOfExposure ? parseDateForCustomDate(this.state.rabiesExposureInfo[index].DateOfExposure, false) : ""}
                                                                                        name={"beginDate"}
                                                                                        aria-labelledby={`DateOfExposure`}
                                                                                        onChange={(e) => this.handleRabiesExposureUpdate(new Date(e.target.value), 'DateOfExposure', index)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label htmlFor="dateOfCollection" className="col-sm-4 col-form-label">Date of Collection</label>
                                                                                <div className="col-sm-8  p-0 m-0" id={'DateOfCollection'}>
                                                                                    <input
                                                                                        className={"form-control"}
                                                                                        autoComplete={"off"}
                                                                                        type={"date"}
                                                                                        value={this.state.rabiesExposureInfo[index].DateOfCollection ? parseDateForCustomDate(this.state.rabiesExposureInfo[index].DateOfCollection, false) : ""}
                                                                                        name={"beginDate"}
                                                                                        aria-labelledby={`DateOfCollection`}
                                                                                        onChange={(e) => this.handleRabiesExposureUpdate(new Date(e.target.value), 'DateOfCollection', index)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row" >
                                                                                <label id="exposureTypeLabel" htmlFor="exposureType" className="col-sm-4 col-form-label">Exposure Type</label>
                                                                                <div className="col-sm-8  p-0 m-0" tabIndex={0} aria-labelledby="exposureType exposureTypeLabel">
                                                                                    <Select
                                                                                        id="exposureType"
                                                                                        name="exposureType"
                                                                                        aria-label={"Exposure Type"}
                                                                                        isSearchable={true}
                                                                                        placeholder={<div className="accessibilityText">Please Select...</div>}
                                                                                        noOptionsMessage={() => "No option"}
                                                                                        className={"state_select"}
                                                                                        options={[{ label: "Bite", value: 1 }, { label: "Scratch", value: 2 }, { label: "Other", value: 3 }]}
                                                                                        onChange={(e) => this.handleRabiesExposureUpdate(e, 'ExposureType', index)}
                                                                                        value={this.state.rabiesExposureInfo && this.state.rabiesExposureInfo[index].ExposureType ? this.state.rabiesExposureInfo[index].ExposureType : null}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            {this.state.rabiesExposureInfo[index].ExposureType?.value === 3 ? <div className="form-group row" >
                                                                                <label id="otherExposureTypeLabel" htmlFor="otherExposureType" className="col-sm-4 col-form-label">Other Exposure Type</label>
                                                                                <div className="col-sm-8  p-0 m-0" tabIndex={0} aria-labelledby="otherExposureType otherExposureTypeLabel">
                                                                                    <input type={"search"} className="form-control" id={"OtherExposureType"}
                                                                                        value={this.state.rabiesExposureInfo[index].OtherExposureType}
                                                                                        autoComplete="off"
                                                                                        onChange={(e) => {
                                                                                            this.handleRabiesExposureUpdate(e.target.value, 'OtherExposureType', index)
                                                                                        }
                                                                                        }
                                                                                        maxLength={80}
                                                                                    />
                                                                                </div>
                                                                            </div> : <></>}
                                                                        </>)
                                                                }) :
                                                                    <section className="d-flex justify-content-center">
                                                                        <button
                                                                            className={"btn btn-primary mb-3"}
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    rabiesExposureInfo: [...this.state.rabiesExposureInfo, { ExposedSpecies: {}, FirstName: "", LastName: "", streetAddress: "", searchAddress: "", city: "", state: "", zipcode: "", phoneNumber: "", DateOfExposure: "", DateOfCollection: "", ExposureType: {}, OtherExposureType: "" }]
                                                                                })
                                                                            }}
                                                                        >
                                                                            Add Exposure Info
                                                                        </button>
                                                                    </section>
                                                                }
                                                                {this.state.rabiesExposureInfo.length > 0 && this.state.rabiesExposureInfo.length < 3 ? <button
                                                                    className={"btn btn-primary float-right mb-3"}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            rabiesExposureInfo: [...this.state.rabiesExposureInfo, { ExposedSpecies: {}, FirstName: "", LastName: "", streetAddress: "", searchAddress: "", city: "", state: "", zipcode: "", phoneNumber: "", DateOfExposure: "", DateOfCollection: "", ExposureType: {}, OtherExposureType: "" }]
                                                                        })
                                                                    }}
                                                                >
                                                                    Additional Exposure
                                                                </button> : <></>}
                                                            </div>
                                                        </div>

                                                    }
                                                    {/* {this.state.showPricingInfo && 
                                                            <div className="card mb-2">
                                                                <div className="card-header verlag-bold" data-toggle="collapse"
                                                                    data-target="#walkinPricingInfoCollapse"
                                                                    onClick={() => this.setState({ walkinPricingInfoArrowDown: !this.state.walkinPricingInfoArrowDown })}
                                                                    role="button"
                                                                    aria-expanded="false"
                                                                    aria-controls="walkinPricingInfoCollapse"
                                                                >
                                                                    <div className="row">
                                                                        <div className="col-10">
                                                                            <h4>Pricing Information</h4>
                                                                        </div>
                                                                        <div className="col-2">
                                                                            {this.state.walkinPricingInfoArrowDown ?
                                                                                (<AiOutlineUp className={'float-right'}
                                                                                    size={30} data-toggle="collapse"
                                                                                    data-target="#walkinPricingInfoCollapse"
                                                                                    role="button" aria-expanded="false"
                                                                                    aria-controls="walkinPricingInfoCollapse" />) :
                                                                                (<AiOutlineDown className={'float-right'}
                                                                                    size={30} data-toggle="collapse"
                                                                                    data-target="#walkinPricingInfoCollapse"
                                                                                    role="button" aria-expanded="false"
                                                                                    aria-controls="walkinPricingInfoCollapse" />)
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        } */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer" style={{ backgroundColor: 'transparent', borderTop: 'none' }}>
                                        <button className={"btn btn-primary float-right mb-3"} onClick={() => this.handleSave()}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )

    }
}

